export const OPTL_HEADER_VERSION = '00'
export const OPTL_HEADER_TRACE_FLAGS = '01'
